var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"about-us"},[(_vm.isLoading)?_c('b-icon',{attrs:{"icon":"three-dots","animation":"cylon","font-scale":"4"}}):_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.pageText)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }